<template>
    <div class="ls-checkboxes">
        <LsInputLabel v-if="label" :label="label" :error="getValidation.invalid" />
        <BField :type="{ 'is-error': getValidation.invalid }">
            <section>
                <div v-for="option in options" :key="option.label" class="field">
                    <BCheckbox
                        v-model="localValue"
                        v-validate="validation"
                        :name="name"
                        :native-value="option.value"
                        :disabled="option.disabled || disabled"
                        test-id="ls-checkbox"
                        type="is-primary-invert"
                        class="ls-checkboxes--checkbox"
                    >
                        <span
                            :class="{
                                'ls-checkboxes--error':
                                    getValidation.invalid && options.length === 1,
                            }"
                            :style="styleOverride"
                            >{{ option.label }}</span
                        >
                    </BCheckbox>
                </div>
            </section>
        </BField>
    </div>
</template>

<script>
import { lsPropTypeHelpers, lsTrackingService, lsValidationService } from 'ls-vue-common';
import VueTypes from 'vue-types';
import _ from 'lodash';
import LsInputLabel from '../LsInputLabel/LsInputLabel.vue';

export default {
    name: 'LsCheckboxes',
    inject: ['$validator'],
    components: {
        LsInputLabel,
    },
    props: {
        value: VueTypes.array.isRequired,
        trackId: VueTypes.custom(lsPropTypeHelpers.trackID).isRequired,
        name: VueTypes.string.isRequired,
        options: VueTypes.arrayOf(
            VueTypes.shape({
                label: VueTypes.string.isRequired,
                value: VueTypes.any.isRequired,
                disabled: VueTypes.bool,
            })
        ).isRequired,
        label: VueTypes.string,
        disabled: VueTypes.bool.def(false),
        validation: VueTypes.object.def(_.constant(null)),
        styleOverride: VueTypes.string,
    },

    computed: {
        localValue: {
            get() {
                return this.value;
            },
            set(value) {
                lsTrackingService.track({
                    event: 'click',
                    target: this.trackId,
                    data: { value },
                });
                this.$emit('input', value);
            },
        },
        getValidation() {
            return lsValidationService.getValidation.call(this, 'checkboxes');
        },
    },
};
</script>

<style lang="scss">
.ls-checkboxes {
    .b-checkbox {
        .control-label {
            padding-left: 9px !important;
            color: $secondary;
        }

        .check {
            border: 1px solid $secondary !important;
            height: 1.2rem !important;
            width: 1.2rem !important;
            border-radius: 2px !important;
            margin-top: 2px;
        }
    }

    .ls-checkboxes--checkbox {
        align-items: flex-start !important;
    }

    .ls-checkboxes--error {
        color: $danger;
    }
}
</style>
